import { logger } from '@/monitoring/logger'

export const download = uri => {
  if (!uri) return
  const element = document.createElement('a')
  element.setAttribute('href', uri)
  element.setAttribute('download', '')
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

export const MIME_TYPES = {
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PDF: 'application/pdf',
  CSV: 'text/csv',
  JSON: 'application/json',
}

export const downloadFromBase64 = (
  base64Content,
  filename,
  mimeType = 'application/octet-stream'
) => {
  try {
    if (!base64Content || !filename) {
      throw new Error('Conteúdo base64 e nome do arquivo são obrigatórios')
    }

    const byteCharacters = atob(base64Content)
    const byteNumbers = new Array(byteCharacters.length)

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: mimeType })

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.style.display = 'none'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(url)

    return true
  } catch (error) {
    throw new Error(
      `Falha ao processar arquivo para download: ${error.message}`
    )
  }
}

export const downloadPdfAsBlob = async url => {
  const response = await fetch(url)
  if (!response.ok) {
    logger.error(`downloadPdfAsBlob`, { errorStatus: response.status })
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  const arrayBuffer = await response.arrayBuffer()
  const fileBlob = new Blob([arrayBuffer], { type: 'application/pdf' })
  const anchorUrl = window.URL.createObjectURL(fileBlob)
  download(anchorUrl)
  window.URL.revokeObjectURL(anchorUrl)
}

export const createObserver = callback => {
  return 'MutationObserver' in window ? new MutationObserver(callback) : {}
}

export const loadScript = ({
  src,
  onLoad = () => null,
  onError = () => null,
  onHead = false,
  defer = false,
  async = false,
}) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.onload = onLoad
  script.onerror = onError
  script.src = src
  script.defer = defer
  script.async = async

  return (onHead ? document.head : document.body).appendChild(script)
}
